<template lang="pug">
  div.drug-group-detail--layout
    div.single-med(v-for="med, num in medicineSet") 
      span {{ med.generic_name }}
      div.btn-remove(@click="deleteDrugFromGroup(num)") x
    hr
    form.form-inline(@submit.prevent="addDrugToGroup")
      div.search-dynamic(style="width: 100%")
        div.input-group
          div.input-group-prepend
            span.input-group-text 選擇藥物
          input.form-control.mr-2(v-model="searchDrug" placeholder="輸入藥碼, 學名或料位號")
          button.btn.btn-primary(@click="addDrugToGroup") 新增
        div.input-options-wrap(v-show="searchMedicines.length !== 0")
          div.input-option(v-for="med, num in searchMedicines" @click="setMedicine(num)") {{med.code}} - {{med.CGMH_number}} - {{ med.generic_name }}

</template>

<script>
export default {
  name: 'DrugGroupDetail',
  props: [
    'rowData', 'rowIndex', 'rowField',
  ],
  data() {
    return {
      medicineSet: [],
      searchDrug: '',
      searchMedicines: [],
      addToGroupMed: {},
    };
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    addDrugToGroup() {
      const group = [this.rowData.id].concat(this.addToGroupMed.group);
      this.instance.patch(`/api/medication/${this.addToGroupMed.id}/`, {
        group,
      })
      .then(() => {
        this.$parent.refresh();
        console.log(this.rowIndex);
        // hack to let the component reload.
        this.$parent.toggleDetailRow(this.rowIndex + 1);
        this.$parent.toggleDetailRow(this.rowIndex + 1);
        this.searchDrug = '';
      });
    },
    deleteDrugFromGroup(index) {
      const med = this.medicineSet[index];
      const editGroup = med.group.filter(e => e !== this.rowData.id);
      this.instance.patch(`/api/medication/${med.id}/`, {
        group: editGroup,
      })
      .then(() => {
        this.$parent.refresh();
      });
    },
    setMedicine(index) {
      this.addToGroupMed = this.searchMedicines[index];
      this.searchDrug = this.addToGroupMed.generic_name;
      this.searchMedicines = [];
    },
    getMedDetail() {
      this.instance.get(`/api/medication-group/${this.rowData.id}/`)
      .then((res) => {
        this.medicineSet = res.data.medicine_set;
      });
    },
  },
  created() {
    this.getMedDetail();
  },
  watch: {
    searchDrug(val) {
      if (val.length >= 3 && this.searchDrug !== this.addToGroupMed.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val,
          },
        })
        .then((res) => {
          this.searchMedicines = res.data.results;
        });
      } else {
        this.searchMedicines = [];
      }
    },
    rowData() {
      this.getMedDetail();
    },
  },
};
</script>

<style lang="sass">
.drug-group-detail--layout
  padding: 10px 0

.single-med
  background-color: steelblue
  color: white
  border-radius: 5px
  display: inline-block
  margin: 2px
  span
    padding: 5px 15px
  .btn-remove
    display: inline-flex
    padding: 5px
    background-color: red
    width: 30px
    // border-left: 1px solid white
    justify-content: center
    align-items: center
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
</style>




// WEBPACK FOOTER //
// DrugGroupDetail.vue?0fb05776